import React, {useEffect, useState} from 'react';
import * as PropTypes from "prop-types";

function PromiseComponent(props) {

  let [status, setStatus] = useState("waiting");
  let [value, setValue] = useState(null);

  useEffect(() => {
    if (props.promise) {
      setStatus("waiting");
      props.promise.then((result) => {
        setStatus("complete");
        setValue(value);
        return result;
      }).catch((error) => {
        setStatus("error");
        setValue(error);
      });
    }
  }, [
    props.promise
  ]);


  return (
    <React.Fragment>
      {status === "complete" && props.then(value)}
      {status === "error" && props.catch && props.catch(value)}
      {status === "waiting" && props.wait && props.wait(value)}
    </React.Fragment>
  );
}

PromiseComponent.propTypes = {
  promise: PropTypes.object.isRequired,
  then: PropTypes.func.isRequired,
  catch: PropTypes.func,
  wait: PropTypes.func,
};

export default PromiseComponent;